import {
  OPEN_CHAT,
  CLOSE_CHAT,
  CREATE_CHAT,
  COLLAPSE_CHAT,
  COLLAPSE_ALL_CHATS,
  CHANGE_CHAT,
  UPDATE_NEW_CHAT,
  UPDATE_CHAT,
  RECALCULATE_MAX_CHATS,
  SET_PROCESS_INSTANCE,
} from "../constants/actionTypes";

export function openChat(chatModel) {
  return {
    type: OPEN_CHAT,
    chat: chatModel,
  };
}

export function closeChat(id) {
  return {
    type: CLOSE_CHAT,
    chatId: id,
  };
}

export function createChat(chatModel) {
  return {
    type: CREATE_CHAT,
    chat: chatModel,
  };
}

export function collapseChat(id) {
  return {
    type: COLLAPSE_CHAT,
    chatId: id,
  };
}

export function collapseAllChats() {
  return {
    type: COLLAPSE_ALL_CHATS,
  };
}

export function changeChat(params) {
  return {
    type: CHANGE_CHAT,
    params: params,
  };
}

export function updateNewChat(chat) {
  return {
    type: UPDATE_NEW_CHAT,
    chat: chat,
  };
}

export function updateChat(chat) {
  return {
    type: UPDATE_CHAT,
    chat: chat,
  };
}

export function recaulculateMaxChats() {
  return {
    type: RECALCULATE_MAX_CHATS,
  };
}

export function setProcessInstance(chatId, processInstance) {
  return {
    type: SET_PROCESS_INSTANCE,
    chatId,
    processInstance,
  };
}
